import { breakpoints, Heading, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { IProductsCount, IIsAsset } from '../model';

import { fifteenPx, colPct } from '.';

export const Header = styled.div<IProductsCount>`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.sm}) {
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: ${({ productsCount }) =>
      productsCount === 4 ? 'row' : 'column'};

    flex: ${({ productsCount }) =>
      productsCount === 4
        ? 'initial'
        : productsCount === 3
        ? `1 1 ${colPct(4)}`
        : `1 1 ${colPct(5)}`};
  }
`;

export const Asset = styled.div<IProductsCount>`
  flex-basis: ${colPct(12)};
  margin-right: 0;
  align-items: center;
  text-align: center;
  order: 5;
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    display: block;
    order: 0;
    text-align: left;
    flex-basis: ${(props) => (props.productsCount === 4 ? colPct(4) : 'auto')};
    margin-right: ${(props) => (props.productsCount === 4 ? fifteenPx : 0)};

    img {
      max-width: 100%;
      height: auto;
      vertical-align: middle;
      border-style: none;
    }
  }

  @media (min-width: ${breakpoints.xl}) {
    flex-basis: ${({ productsCount }) =>
      productsCount === 4 ? colPct(3) : 'auto'};
  }
`;

export const Content = styled.div<IProductsCount & IIsAsset>`
  font-weight: 300;
  line-height: 1.4;
  flex-basis: ${colPct(12)};
  padding: 0 ${fifteenPx} ${fifteenPx};

  @media (min-width: ${breakpoints.md}) {
    flex-basis: ${(props) =>
      props.productsCount === 4 && props.isAsset ? colPct(8) : colPct(12)};

    margin-right: ${(props) =>
      props.productsCount === 4 && props.isAsset ? '5rem' : 0};

    padding: ${(props) =>
      props.productsCount === 4 && props.isAsset
        ? `0 ${fifteenPx} ${fifteenPx}`
        : fifteenPx};
  }
`;

export const Title = styled(Heading.H3)`
  ${theme.typography.labelLarge}
  strong {
    font-weight: 500;
  }

  @media (min-width: ${breakpoints.md}) {
    font-size: 1.75rem !important;
    line-height: 2rem !important;
    margin: 0.6rem 0 1rem !important;
  }
`;

export const Description = styled.div`
  ${theme.typography.bodyRegular}
  color: ${theme.color.text.secondary};
  word-break: break-word;

  @media (min-width: ${breakpoints.md}) {
    font-size: 1rem !important;
    font-weight: 300 !important;
  }
`;
